import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { DialogWindowContext } from "../../Contexts/DialogueWindowContext";
import { CheatSheetContext } from "../../Contexts/CheatSheetsContext";
import { CurrentUserContext } from "../../Contexts/CurrentUserContext";
import { IonIcon } from "@ionic/react";
import {
  documentTextOutline,
  createOutline,
  trashOutline,
} from "ionicons/icons";
import CheatSheetEdit from "./CheatSheetEdit";
import { deleteFolderContents, deleteCheatSheet } from "../../Firebase";

const CheatSheetsIndexContainer = styled.div`
  margin-top: 10px;
  padding: 15px 10px;
  h1 {
    color: var(--accent-color-dark);
    width: 100%;
    font-size: 25px;
    font-weight: 500;
  }
  @media (max-width: 400px) {
    h1 {
      font-size: 20px;
    }
  }
`;

const CheatSheatsList = styled.div`
  width: fit-content;
  max-width: 100%;
`;

const CheatCheatCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--accent-color-dark);
  border-radius: 10px;
  margin: 15px 10px;
  padding: 10px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  transition: 0.2s ease-in-out;

  h2 {
    font-size: 18px;
    cursor: pointer;
    margin-right: 8px;
  }
  ion-icon {
    font-size: 20px;
    margin-right: 8px;
    color: "var(--accent-color-dark)";
    cursor: pointer;
  }

  .edit {
    color: green;
  }

  .trash {
    color: #e30000;
  }

  &:hover {
    box-shadow: 0px 2px 1px -4px rgba(0, 0, 0, 0.2),
      0px 2px 4px 1px rgba(0, 0, 0, 0.14), 0px 1px 2px 2px rgba(0, 0, 0, 0.12);
  }

  &&.new-cheat-sheet {
    background-color: var(--accent-color-dark);
    color: white;
    cursor: pointer;
    
    h2 {
    font-size: 18px;
    font-weight: 400;
    margin: 0 30px;
  }

    .edit {
    color: white;
  }
  }
`;

const LinkBox = styled.div`
  display: flex;
  align-items: center;
`;

const EditBox = styled.div`
  display: flex;
  align-items: center;
`;

export default function CheatSheetsIndex(props: Props) {
  const DialogWindow = useContext(DialogWindowContext);
  const CheatSheets = useContext(CheatSheetContext);
  const [cheatSheets, setCheatSheets] = useState<CheatSheet[]>([]);
  const CurrentUser = useContext(CurrentUserContext);

  useEffect(() => {
    CheatSheets.getAllCheatSheets();
  }, []);

  useEffect(() => {
    setCheatSheets(CheatSheets.cheatSheets);
  }, [CheatSheets.cheatSheets]);

  function onDelete(cheatSheetId: string) {
    deleteFolderContents(cheatSheetId);
    deleteCheatSheet(cheatSheetId);
  }

  function onEdit(cheatSheet: CheatSheet) {
    DialogWindow.setDialogProps((prevProps) => ({
      ...prevProps,
      showEditWindow: true,
      header: `Edit CheatSheet`,
      children: <CheatSheetEdit cheatSheet={cheatSheet} />,
    }));
  }

  return (
    <CheatSheetsIndexContainer>
      <h1>Cheat Sheets</h1>
      <CheatSheatsList>
        {cheatSheets.map((cheatSheet, index) => (
          <>
            <CheatCheatCard id={`cheatSheetCard-${index}`}>
              <LinkBox onClick={() => window.open(cheatSheet.url, "_blank")}>
                <IonIcon icon={documentTextOutline} />
                <h2>{cheatSheet.title}</h2>
              </LinkBox>
              {CurrentUser?.currentUser?.PCRoles.some(
                (role) => role.role === "admin"
              ) && (
                <>
                  <EditBox>
                    <IonIcon
                      className="edit"
                      onClick={() => {
                        onEdit(cheatSheet);
                      }}
                      icon={createOutline}
                    />
                    <IonIcon
                      className="trash"
                      onClick={() => {
                        onDelete(cheatSheet.cheatSheetId);
                      }}
                      icon={trashOutline}
                    />
                  </EditBox>
                </>
              )}
            </CheatCheatCard>
          </>
        ))}

        {CurrentUser?.currentUser?.PCRoles.some(
          (role) => role.role === "admin"
        ) && (
          <CheatCheatCard
            className="new-cheat-sheet"
            onClick={() =>
              onEdit({
                title: "",
                tags: [],
                url: "",
                cheatSheetId: "",
              })
            }
          >
            <LinkBox>
              <h2>Add a new Cheat Sheet</h2>
            </LinkBox>
            <EditBox>
              <IonIcon className="edit" icon={createOutline} />
            </EditBox>
          </CheatCheatCard>
        )}
      </CheatSheatsList>
    </CheatSheetsIndexContainer>
  );
}

interface Props {}
